import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromTower from 'app/state/tower';

export const towerDetailResolverFn: ResolveFn<any> = (route, state) => {
  const store = inject(Store);
  const id = route.paramMap.get('id') ?? '';
  if (!id) return false;

  store.dispatch(fromTower.setItem({ id: id }));
  return true;
};
